/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectsQuery } from '../../models/get-projects-query';
import { GetProjectsQueryResult } from '../../models/get-projects-query-result';

export interface ApiProjectGetAllProjectsPost$Plain$Params {
      body?: GetProjectsQuery
}

export function apiProjectGetAllProjectsPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectGetAllProjectsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectGetAllProjectsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectsQueryResult>;
    })
  );
}

apiProjectGetAllProjectsPost$Plain.PATH = '/api/Project/GetAllProjects';
